import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard {
  constructor(private userService: UserService) {}

  canActivate(): boolean | UrlTree {
    return this.userService.isAdmin();
  }
}
